import { NextPageContext } from "next";

import { IAutoComplete, IAutoCompleteItems } from "models/autocomplete";
import { fetchAtClientSide } from "utils/misc/fetchClient";

export const getAutoCompleteSearchClient = async (
  context: NextPageContext,
  searchTerm: string
): Promise<Array<IAutoCompleteItems>> => {
  let url = `posts/auto-complete?AutoComplete%5Bq%5D=${searchTerm}`;
try {
  const data = await fetchAtClientSide<IAutoComplete>({ url });
  if ("searchModels" in data) return data.searchModels || [];
} catch(err) {
  console.error(`Error! Couldn't get autocomplete search items!`, err);
  return [];
}
};
